import { render, staticRenderFns } from "./taskAdd.vue?vue&type=template&id=a1e96ba4&scoped=true&"
import script from "./taskAdd.vue?vue&type=script&lang=js&"
export * from "./taskAdd.vue?vue&type=script&lang=js&"
import style0 from "./taskAdd.vue?vue&type=style&index=0&id=a1e96ba4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e96ba4",
  null
  
)

export default component.exports